const countryBlacklist = {
  MP: 'Northern Mariana Islands',
  VI: 'U.S. Virgin Islands',
  GB: 'United Kingdom',
  GU: 'Guam',
  BC: 'British Columbia',
  CU: 'Cuba',
  SY: 'Syria',
  PR: 'Puerto Rico',
  SG: 'Singapore',
  KP: 'North Korea',
  IR: 'Iran',
  VC: 'Saint Vincent and the Grenadines',
  US: 'United States',
  MM: 'Myanmar',
  RU: 'Russia',
};

export default countryBlacklist;
